const roundedMin = (n, upperLimit) => Math.round(Math.min(n, upperLimit));
export const calculateDimensions = ({ containerWidth = 0, containerHeight = 0, imgWidth: maxWidth = Infinity, imgHeight: maxHeight = Infinity, desiredPixelRatio, }) => {
    const adjustedContainerWidth = Math.round(containerWidth * desiredPixelRatio);
    const adjustedContainerHeight = Math.round(containerHeight * desiredPixelRatio);
    const desiredWidth = roundedMin(adjustedContainerWidth, maxWidth);
    const desiredHeight = roundedMin(adjustedContainerHeight, maxHeight);
    return {
        desiredWidth: desiredWidth || undefined,
        desiredHeight: desiredHeight || undefined,
    };
};
//# sourceMappingURL=calculateDimensions.js.map